import badges from '@/utilities/AllBadges'
import colors from '@/utilities/ProfileColors'
import miniQuests from '@/utilities/MiniQuests'

const UserStore = {
  namespaced: true,
  state: {
    username: '',
    authKey: '',
    profileColor: 'blueGradient',
    level: 1,
    expCurrent: 0,
    expNextLevelTarget: 5,
    expTotal: 0,
    performancePoint: 0,
    zenny: 50,
    badges: badges.slice(),
    colors: colors.slice(),
    finishedTask: [],
    lastLogin: new Date(),
    miniQuests: miniQuests.slice(),
    isMiniQuestOpen: true,
    isSettingsOpen: true,
    darkMode: false,
    isTutorialShown: false,
    expTarget: [5, 10, 10, 15, 15, 20, 25, 30, 35, 40, 50, 60, 80, 100, 125, 150, 180, 210, 250, 300, 375, 450, 500],
  },
  mutations: {
    setCredential(state, {username, authKey}) {
      state.username = username
      state.authKey = authKey
    },
    setGamificationData(state, {level, expCurrent, expNextLevelTarget, expTotal, performancePoint, badges}) {
      state.level = level
      state.expTotal = expTotal
      state.expCurrent = expCurrent
      state.expNextLevelTarget = expNextLevelTarget
      state.performancePoint = performancePoint
      state.badges = badges
    },
    addPerformancePoint(state, {value}) {
      state.performancePoint += value
    },
    setPerformancePoint(state, {value}) {
      state.performancePoint = value
    },
    addZenny(state, {value}) {
      state.zenny += value
    },
    decreaseZenny(state, {value}) {
      state.zenny -= value
    },
    setProfileColor(state, {color}) {
      state.profileColor = color
    },
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode
    },
    incrementExp(state) {
      state.expCurrent++
      state.expTotal++
    },
    levelUp(state) {
      const newLevelTarget = state.expTarget.shift()
      state.level++
      state.expNextLevelTarget = newLevelTarget
      state.expCurrent = 0
    },
    resetProgress(state) {
      state.profileColor ='blueGradient'
      state.level = 1
      state.expCurrent = 0
      state.expNextLevelTarget = 5
      state.expTotal = 0
      state.performancePoint = 0
      state.badges = badges.slice()
      state.colors = colors.slice()
      state.miniQuests = miniQuests.slice()
      state.zenny = 50
      state.finishedTask = []
      state.isTutorialShown = false
      state.expTarget = [5, 10, 10, 15, 15, 20, 25, 30, 35, 40, 50, 60, 80, 100, 125, 150, 180, 210, 250, 300, 375, 450, 500]
    }
  },
  getters: {
    hasNotLogin(state) {
      return state.username === '' && state.authKey === ''
    },
    getAllBadgesCount(state) {
      return state.badges.length
    },
    getBadgesCount(state) {
      return state.badges.filter(item => item.acquired).length
    },
    getZenny(state) {
      return state.zenny
    },
    getProfileColor(state) {
      return state.profileColor
    },
    getTaskFinishedCount(state) {
      return state.finishedTask.length
    },
    getLessonFinishedCount(state) {
      return state.finishedTask.filter(item => item.type === 'lesson').length
    },
    getSingleFinishedCount(state) {
      return state.finishedTask.filter(item => item.type === 'single').length
    },
    getQuestFinishedCount(state) {
      return state.finishedTask.filter(item => item.type === 'quest').length
    },
    getScores(state) {
      return state.finishedTask.reduce((total, item) => total + item.score, 0)
    },
    getAverageScores(state) {
      const totalScore = state.finishedTask.reduce((total, item) => total + item.score, 0)
      return totalScore === 0 ? 0 : totalScore/state.finishedTask.length
    },
    getSilverScoresCount(state) {
      return state.finishedTask.filter(item => item.score > 49.99 && item.score < 99.99).length
    },
    getGoldScoresCount(state) {
      return state.finishedTask.filter(item => item.score > 99.99).length
    },
    getPerformance(state) {
      state.finishedTask.sort((a, b) => b.expGained - a.expGained)
      let performance = 0
      for (let i in state.finishedTask) {
        performance += Math.floor(state.finishedTask[i].expGained * Math.pow(0.95, i))
      }

      return performance
    }
  },
  actions: {
    logOut({commit}) {
      commit('setCredential', {username: '', authKey: ''})
    },
    incrementExp({commit, state}) {
      commit('incrementExp')
      if (state.expCurrent === state.expNextLevelTarget) commit('levelUp')
    }
  }
}

export default UserStore
